module.exports = __webpack_public_path__ + "assets/b99cc2d22ce5e43a2480fea3a4415a6e.png";